import { render } from "./RecentPurchases.vue?vue&type=template&id=3b9731f5"
import script from "./RecentPurchases.vue?vue&type=script&lang=js"
export * from "./RecentPurchases.vue?vue&type=script&lang=js"

import "./RecentPurchases.vue?vue&type=style&index=0&id=3b9731f5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__